import React, {useState, useEffect, useRef} from 'react';
import {Table, Input, Card, Button, Dropdown, Icon} from "antd";
import {queryClinicCustomer} from '@/services/customer';
import { GENDER_ENUM, HTTP_SUCCESS_CODE } from '@/utils/consts';
import styles from "./index.less";

const PAGE_SIZE = 20;

const Picker = ({value, onChange, clinicId}) => {
  const [tableData, setTableData] = useState(() => []);
  const [pagination, setPagination] = useState(() => ({current: 1, total: 0, pageSize: PAGE_SIZE}));
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCustomerData({pageNo: pagination.current, clinicId, search});
  }, [pagination.current, clinicId]);

  useEffect(() => {
    setPagination(prevState => ({...prevState, current: 1}));
  }, [clinicId]);

  const fetchCustomerData = async ({pageNo, clinicId, search = ''}) => {
    setLoading(true);
    const res = await queryClinicCustomer({pageNo, pageSize: PAGE_SIZE, name: search, clinicId});
    setLoading(false);

    if (res.code !== HTTP_SUCCESS_CODE) return;

    const {rows, totalCount} = res.data;
    setTableData(rows || []);
    setPagination(prevState => ({...prevState, total: totalCount}));
  };

  const handlePaginationChange = (pageNo, pageSize) => {
    setPagination(prevState => ({...prevState, current: pageNo, pageSize}));
  };

  const handleSearch = () => {
    fetchCustomerData({pageNo: 1, clinicId, search});
  };

  const columns = [
    {
      title: '姓名',
      dataIndex: 'name',
    },
    {
      title: '性别',
      dataIndex: 'gender',
      align: 'center',
      render: (gender) => gender ? (GENDER_ENUM.find(_ => _.value === gender) || {}).label : undefined
    },
    {
      title: '所属门店',
      dataIndex: 'clinicShortName',
    },
    {
      title: '客户等级',
      align: 'center',
      dataIndex: 'classification',
    },
    {
      title: '渠道名称',
      key: 'channelName',
      render: (_, record) => {
        let channelName = '';

        if (record.firstChannel) channelName = record.firstChannel;
        if (record.secondChannel) {
          channelName = channelName.length ? `${channelName}/${record.secondChannel}` : record.secondChannel;
        }

        return channelName;
      }
    }
  ];


  const tableProps = {
    columns,
    loading,
    rowKey: 'customerId',
    dataSource: tableData,
    pagination: {
      ...pagination,
      onChange: handlePaginationChange
    },
    rowClassName: (record) => record.customerId === value.customerId ? 'active' : '',
    size: 'small',
    scroll: {y: 300},
    onRow: (record) => {
      return {
        onClick: event => {
          onChange(record);
        }
      }
    }
  };

  return (
    <Card className={styles['customer-picker']} size='small'>
      <div className="search-zone">
        <Input
          allowClear={true}
          autoFocus={false}
          placeholder="手机号、姓名、微信号"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{width: 250}}
          onPressEnter={handleSearch}
        />
        <Button style={{marginLeft: 15}} loading={loading} onClick={handleSearch}>查询</Button>
      </div>
      <div className="result-zone">
        <Table {...tableProps} />
      </div>
    </Card>
  );
};

const CustomerPicker = ({value, onChange, size, clinicId, disabled = false}) => {
  value = value || {}
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  const handleValueChange = (customer) => {
    const {customerId, name, personalDoctorId, consultantDoctorId} = customer;
    onChange({customerId, customerName: name, clinicId: customer.clinicId, personalDoctorId, consultantDoctorId});
    setVisible(false);
  };

  const handleInputChange = (e) => {
    e.stopPropagation();

    if (!e.target.value) {
      onChange(undefined);
    }
  };

  return (
    <Dropdown
      disabled={disabled}
      overlayStyle={{width: 700}}
      overlay={<Picker value={value} onChange={handleValueChange} size={size} clinicId={clinicId} />}
      trigger={['click']}
      visible={visible}
      onVisibleChange={visible => setVisible(visible)}
      getPopupContainer={triggerNode => triggerNode.parentNode}
    >
      <Input
        size={size}
        ref={ref}
        value={value.customerName}
        allowClear={true}
        onChange={handleInputChange}
      />
    </Dropdown>
  );
};

export default CustomerPicker;
